export default function formatDateView(date) {
    if (date == null || date == '') {
        return null;
    } else {
        let localDate = new Date(date);
        return localDate.toLocaleDateString("en-GB", {
            day: "2-digit",   // Ensures the day is two digits
            month: "2-digit", // Ensures the month is two digits
            year: "numeric"   // Shows the full year
        });
    }
}
